/** See `src/i18n/locales/en/pilots.ts`. */
export const pilots = {
  page: {
    title: 'Pilots',
    lead: 'Pilots die lopen bij {{company}}.',
    noScope: 'Selecteer een bedrijf om de pilots te zien.',
    listTitle: 'Pilots',
    empty: 'Nog geen pilots.',
  },
  status: {
    draft: 'Concept',
    baseline: 'Nulmeting',
    active: 'Actief',
    interim_review: 'Tussentijdse evaluatie',
    final_review: 'Eindevaluatie',
    completed: 'Afgerond',
    scaled: 'Opgeschaald',
  },
  phases: {
    baseline: 'Nulmeting',
    interim: 'Tussentijdse evaluatie',
    final: 'Eindevaluatie',
  },
  kpis: {
    participationRate: 'Deelnamegraad',
    activeUsers: 'Actieve gebruikers',
    dailyUsage: 'Dagelijks gebruik',
    satisfaction: 'Medewerkerstevredenheid',
    avgVitality: 'Gem. vitaliteit',
    aiCoachUsage: 'AI-coachgebruik',
    challengeUsage: 'Challengegebruik',
    rolloutReadiness: 'Advies uitrol',
  },
  form: {
    title: 'Nieuwe pilot',
    name: 'Naam',
    startDate: 'Startdatum',
    departments: 'Afdelingen',
    submit: 'Pilot aanmaken',
  },
  detail: {
    title: 'Pilot',
    lead: "Evaluatie van de vitaliteitspilot met KPI's, trends, conclusies en een onderbouwd uitrolbesluit.",
    exportPdf: 'Exporteer rapport (PDF)',
    hero: {
      badge: {
        success: 'Pilot geslaagd',
        partial: 'Pilot in voortgang',
        atRisk: 'Aandacht vereist',
        pending: 'Pilot loopt',
      },
      goals: {
        success: 'Alle KPI-doelstellingen behaald',
        partial: 'Een deel van de KPI-doelstellingen behaald',
        atRisk: 'KPI-doelstellingen nog niet behaald',
        pending: 'Nog onvoldoende data voor een advies',
      },
      headlinePrefix: {
        success: 'De pilot bewijst dat NOLATR Fit vitaliteit meetbaar verbetert — advies:',
        partial: 'De pilot laat verbetering zien — advies:',
        atRisk: 'De pilot laat nog geen meetbare verbetering zien — advies:',
        pending: 'Er is nog onvoldoende data voor een advies over',
      },
      headlineAdvice: {
        success: 'opschalen naar de hele organisatie.',
        partial: 'de pilot verlengen voor meer data.',
        atRisk: 'eerst bijsturen vóór opschalen.',
        pending: 'opschalen.',
      },
    },
    summary: {
      participation: 'Deelname',
      dailyActive: 'Dagelijks actief',
      stress: 'Stress',
      sleep: 'Slaap',
      goal: 'doel {{value}}%',
      vsBaseline: 'vs nulmeting',
      minutes: '{{value}} min',
    },
    aiSummaryTitle: 'AI-samenvatting',
    recommendationEmpty: 'Nog geen samenvatting ingevuld.',
    kpisTitle: "KPI's",
    chartTitle: 'Vitaliteit & activiteit tijdens de pilot',
    chartCurrent: 'Huidig',
    noData: 'Nog geen data.',
    participantCount: '{{count}} deelnemers',
    evaluationsTitle: 'Conclusies & aanbevelingen',
    conclusionsTitle: 'Conclusies',
    recommendationsListTitle: 'Aanbevelingen',
    evaluationsEmpty: 'Nog geen evaluaties vastgelegd.',
    evaluationPhase: 'Fase',
    evaluationConclusions: 'Conclusies',
    evaluationRecommendations: 'Aanbevelingen',
    decisionTitle: 'Besluit',
    scaleRequiresCompleted: 'Opschalen kan pas nadat de eindevaluatie is afgerond.',
  },
  actions: {
    new: 'Nieuwe pilot',
    cancel: 'Annuleren',
    save: 'Opslaan',
    edit: 'Bewerken',
    addEvaluation: 'Evaluatie toevoegen',
    extend: 'Verlengen',
    scale: 'Opschalen',
  },
} as const;
